import React, { useState, useEffect }from 'react'
import './Header.css'
import { Link, NavLink } from 'react-router-dom';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const loadCart = JSON.parse(localStorage.getItem("cart") || "[]")

function Header({cartQuantity}) {

const[click, setClick] = useState(false);
const[button, setButton] = useState(true);

const handleClick = () => setClick(!click);
const closeMobileMenu = () => setClick(false);

const showButton = () => {
    if(window.innerWidth <= 960) {
        setButton(false);
    } else{
        setButton(true);
    }
}

useEffect(() => {
    showButton();
}, []);

window.addEventListener('resize', showButton);

    return (
        <div className="navbar">
            <div className="navbar-container">
            <NavLink onClick ={closeMobileMenu} to="/" exact >
                <img className="navbar-logo" src="https://i1.sndcdn.com/artworks-000629583577-r5i9lw-t200x200.jpg" alt=""/>
                </NavLink>
                <h2 className="site-title"> Kam's Music</h2>

                <div className = 'menu-icon' onClick={function () {
                        handleClick();
                    }}> <i className = {click ? 'fas fa-times' : 'fas fa-bars'}/></div>
                <ul className = {click ? 'nav-menu active' : 'nav-menu'}>
                    <li className='nav-item'><NavLink className='nav-links' onClick ={closeMobileMenu} to="/" exact > Home</NavLink></li>

                    <li className='nav-item'><NavLink className='nav-links' onClick ={closeMobileMenu} to="/shop" exact > Shop</NavLink></li>
                    <li className='nav-item'><NavLink className='nav-links' onClick ={closeMobileMenu} to="/about" exact > About</NavLink></li>
                    <li className='nav-item'><NavLink className='nav-links' onClick= {closeMobileMenu} to="/shop/cart" exact ><ShoppingCartIcon/>{cartQuantity}</NavLink></li>
                </ul>

                </div>
        </div>
    )
}

export default Header
